var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 8.33325V16.6666M8.33325 12.4999H16.6666M22.9166 12.4999C22.9166 18.2529 18.2529 22.9166 12.4999 22.9166C6.74695 22.9166 2.08325 18.2529 2.08325 12.4999C2.08325 6.74695 6.74695 2.08325 12.4999 2.08325C18.2529 2.08325 22.9166 6.74695 22.9166 12.4999Z",
    stroke: "#3373EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleOn);
export default __webpack_public_path__ + "static/media/plus-circle-on.2b6b9621b9ceaee7ea71a7d612ac7d79.svg";
export { ForwardRef as ReactComponent };